module.exports = __webpack_public_path__ + "e1bc4e7617650c8b0ad6e3490f60613f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/logo-mark.svg
 ** module id = 51
 ** module chunks = 0
 **/